/**
 * Standalone public forms rendered under the Apply shell and linked from the
 * marketing site (tento.com/for-partners, /for-vendors). They must be usable
 * WITHOUT logging in, so nothing about a visitor's (possibly stale) session may
 * move them off the page:
 *  - a recovered session must not resume the loan/BCM flow (App.js checkSession);
 *  - a session that fails to refresh must be dropped silently instead of
 *    redirecting to Auth0 (Auth0LoggedInSetState). 2026-10-27: that redirect is
 *    how /partners bounced returning visitors to login.
 */
export const STANDALONE_PUBLIC_PATHS = ['/partners', '/contact'];

export const isStandalonePublicPath = (pathname: string | undefined | null): boolean =>
  STANDALONE_PUBLIC_PATHS.includes((pathname ?? '').replace(/\/+$/, '') || '/');
